export default "__VITE_ASSET__DDg3C6nX__"